import { createContext, useContext, useState, useEffect } from 'react';

const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
    const [admin, setAdmin] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const storedAdmin = localStorage.getItem('admin');
        if (storedAdmin) {
            setAdmin(JSON.parse(storedAdmin));
        }
        setLoading(false);
    }, []);

    const logout = () => {
        localStorage.removeItem('admin');
        localStorage.removeItem('token');
        setAdmin(null);
        // Removed window.location.reload() to allow state-based key redirection
    };

    return (
        <AdminContext.Provider value={{ admin, loading, setAdmin, logout }}>
            {children}
        </AdminContext.Provider>
    );
};

export const useAdmin = () => useContext(AdminContext);
